<template>
  <el-container direction="vertical"
                id="app">
    <app-header></app-header>
    <el-main>
      <router-view></router-view>
      <app-pwa-installer></app-pwa-installer>
      <el-backtop target=".el-main"></el-backtop>
    </el-main>
  </el-container>
</template>

<script>
import AppHeader from './components/header/Header'
import AppPwaInstaller from './components/pwa-installer/PwaInstaller'

export default {
  components: { AppPwaInstaller, AppHeader }
}
</script>
